import * as React from 'react'
import { InputProps } from '@/components/content/Input'
import styled from 'styled-components'
import { colors, colorSystem } from '@/styles/theme'
import Text from '@/components/content/Text'
import { ExpectedAllocationItems } from '@/services/outbound/outboundWaitingStatus/types'
import { DEFAULT_EXPECTED_ALLOCATION_LIST } from '@/services/outbound/outboundWaitingStatus/consts'
import { Utils } from '@/utils/Utils'

interface Props extends InputProps {
  item?: ExpectedAllocationItems
  filteredWarehouses?: string[]
}

function SummaryPanel({ item, filteredWarehouses }: Props) {
  const itemList = [
    {
      warehouseName: '센터 미할당',
      warehouseCode: 'notAllocated',
      orderCount: item?.totalNotAllocatedOrderCount || 0,
      orderPcs: item?.totalNotAllocatedOrderPcs || 0,
    },
    ...(item?.centerData || DEFAULT_EXPECTED_ALLOCATION_LIST).filter((center) => filteredWarehouses?.includes(center.warehouseCode)),
  ]

  return (
    <SummaryWrapper>
      <SummaryContainer>
        <SummaryHeader>
          <Text kind="Headline_16_bold">센터별 예상 할당 수량</Text>
          <div>
            <Text kind="Body_12_regular" color={colorSystem.text.common.secondary}>
              pcs 수
            </Text>
          </div>
        </SummaryHeader>

        <CenterItemsContainer>
          {itemList.map((listItem, index) => (
            <CenterItem key={`summary-item-${listItem.warehouseCode || index}`}>
              <Text kind="Body_14_regular" color={colors.gray900}>
                {listItem.warehouseName}
              </Text>
              <OrderCountDisplay>
                <Text kind="Body_14_bold" color={colors.gray900}>
                  {Utils.getCommaNum(listItem.orderPcs) || 0}
                </Text>
              </OrderCountDisplay>
            </CenterItem>
          ))}
        </CenterItemsContainer>
        <DividerLine />
        <TotalSummary>
          <Text kind="Body_14_regular" color={colors.gray900}>
            총합
          </Text>
          <OrderCountDisplay>
            <Text kind="Body_14_bold" color={colors.gray900}>
              {Utils.getCommaNum(item?.totalOrderPcs) || 0}
            </Text>
          </OrderCountDisplay>
        </TotalSummary>
      </SummaryContainer>
    </SummaryWrapper>
  )
}

const SummaryWrapper = styled.div`
  height: 650px;
`

const SummaryContainer = styled.div`
  width: 280px;
  height: fit-content;
  max-height: 650px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid ${colorSystem.border.table};
`

const SummaryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const CenterItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  overflow-y: auto;
  min-height: 0;
`

const CenterItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 10px;
  border-radius: 8px;
  background: ${colors.gray050};
`

const OrderCountDisplay = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`

const DividerLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${colorSystem.border.pinnedTable};
`

const TotalSummary = styled.div`
  padding: 0 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export default SummaryPanel
